<template>
  <div style="background-color: #fafafa;padding: 20px">

    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/package' }">问题分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row style="margin-top: 15px">
      <el-col :span="22" style="display: flex;align-items: center">
        <div style="font-size: 25px"><p>问题分析</p></div>
        <div style="margin-left: 20px">
          <el-button size="small" type="primary" :loading="ruleForm.loading" @click="addProblemOpen">新增问答</el-button>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="color: #EF6C00;font-size: 25px"><i class="el-icon-loading" v-if="loading2"></i></div>
      </el-col>
    </el-row>

    <div style="width: 100%; font-size: 25px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="margin-top: 10px;width: 800px">
        <el-form-item label="关键词：" prop="search" v-if="!answer.value && ruleForm.problem !== 4" >
          <el-input :placeholder="ruleForm.problem === 1 ? 'PID/导购ID/导购手机号/导购名':'导购手机号/导购ID'" style="width: 400px" v-model="ruleForm.search" clearable></el-input>
        </el-form-item>
        <el-form-item label="申报时间：" v-if="!answer.value && ruleForm.problem === 1" prop="timeRange" style="margin-left: 80px;">
          <div style="display: flex; align-items: center;">
            <el-select v-model="ruleForm.timeRange" placeholder="请选择问题" style="width: 320px">
              <el-option key="0" label="最近两周" value="0"/>
              <el-option key="1" label="最近一个月" value="1"/>
              <el-option key="2" label="最近三个月" value="2"/>
              <el-option key="3" label="最近半年" value="3"/>
              <el-option key="4" label="最近一年" value="4"/>
              <el-option key="all" label="所有时间" value="all"/>
            </el-select>
            <div style="color: red;margin-left: 10px">仅对非流程编号的关键词查询生效</div>
          </div>
        </el-form-item>
        <el-form-item label="小票交易时间：" v-if="!answer.value && ruleForm.problem === 1" prop="ticketTime">
          <el-date-picker popper-class="datePicker" v-model="ruleForm.ticketTime" type="datetime" style="width: 400px" clearable format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :editable="false" placeholder="选择小票交易时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="问题：" prop="problem" class="problem">
          <el-select v-model="ruleForm.problem" filterable placeholder="请选择问题" @change="problemChange" style="width: 400px">
            <el-option
              v-for="item in ruleForm.problemList"
              :key="item.value"
              :label="item.text"
              :value='item.value'>
            </el-option>
          </el-select>
          <div style="font-size: 12px;color: #8c939d">{{ruleForm.problemList.find(it => it.value === ruleForm.problem).description || ''}}</div>
        </el-form-item>
        <el-form-item v-if="answer.value" label="回答：">
          <div style="white-space: pre-line">{{answer.value}}</div>
        </el-form-item>
        <el-form-item label="只查异常单：" prop="abnormal" v-if="!answer.value && ruleForm.problem === 1">
          <el-checkbox v-model="ruleForm.abnormal"/>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!answer.value" :loading="ruleForm.loading" @click="searchProblem">查询</el-button>
          <el-button v-else @click="handleCopy2('.copy2-',answer.index)">复制</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="results.length > 0">
      <div v-if="ruleForm.problem === 4" style="display: flex;justify-content: space-between">
        <el-button-group>
          <el-button size="small" :disabled="resultIndex === 0" :type="resultIndex === 0 ? 'primary':''" plain @click="resultIndex = 0">常规滞留单({{results[0].length}})</el-button>
          <el-button size="small" :disabled="resultIndex === 1" :type="resultIndex === 1 ? 'primary':''" plain @click="resultIndex = 1">无提成规则({{results[1].length}})</el-button>
        </el-button-group>
        <el-button size="small" type="primary" plain v-if="resultIndex === 1 && results[resultIndex].length > 0 && !suspend.batch" @click="suspend.batch = true">批量挂起</el-button>
        <el-button-group v-if="resultIndex === 1 && results[resultIndex].length > 0 && suspend.batch">
          <el-button size="small" type="primary" plain :disabled="suspend.pids.length === 0" @click="chooseSuspend()">批量挂起{{suspend.pids.length > 0 ? '(' + suspend.pids.length + ')' : ''}}</el-button>
          <el-button size="small" plain @click="cancelSuspend()">取消</el-button>
        </el-button-group>
      </div>
      <el-table
        v-if="ruleForm.problem === 1 || ruleForm.problem === 4"
        :data="ruleForm.problem === 4 ? results[resultIndex] : results"
        max-height="600"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="小票"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.img + '?x-oss-process=image/resize,m_pad,w_100,h_100'"
              :preview-src-list="[scope.row.img]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="pid"
          prop="pid"
          align="center"
          width="130">
        </el-table-column>
        <el-table-column
          label="导购"
          prop="saleName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="供应商"
          prop="supplierName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="品牌"
          prop="brandName"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="申报时间"
          prop="createdAt"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="流转时间"
          prop="aaCreatedAt"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="流程状态"
          prop="statusName"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="s">
            <el-tooltip v-if="s.row.type !== '4'" effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{s.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{s.row.message}}</div>
            </el-tooltip>
            <el-tooltip v-if="s.row.type === '4' && s.row.sub" effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{s.row[s.row.sub].message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{s.row[s.row.sub].message}}</div>
            </el-tooltip>
            <div v-if="s.row.type === '4' && !s.row.sub">
              <div>交易时间：{{s.row.ticketTime}}</div>
              <div>
                <el-button size="small" @click="$set(s.row, 'sub', 'sub1')">正确</el-button>
                <el-button size="small" @click="openNewTicket(s.row)">错误</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.type == '7'" style="margin-bottom: 20px">
              <el-button size="small" v-if="!suspend.batch" @click="chooseSuspend(scope.row.pid)">挂起</el-button>
              <el-checkbox-group v-else v-model="scope.row.suspend" @change="(val) => checkedClick(val,scope.row.pid,scope.$index)">
                <el-checkbox label="挂起"/>
              </el-checkbox-group>
            </div>
            <div><el-button size="small" v-if="scope.row.type && !(scope.row.type === '4' && !scope.row.sub)" @click="scope.row.copyMessage ? handleCopy2('.copy-',scope.$index) : (scope.row.type === '4' ? handleCopy(scope.row[scope.row.sub].message):handleCopy(scope.row.message))">复制</el-button></div>
            <div v-if="scope.row.type == '14'" style="margin-top: 10px"><el-button size="small" @click="openInvite(scope.row)">邀请</el-button></div>
            <div v-if="scope.row.type == '12' && (scope.row.position === '审单员' || scope.row.autoBack)" style="margin-top: 10px"><el-button size="small" @click="retrial(scope.row,scope.$index)">取回</el-button></div>
            <div v-if="scope.row.statusName === '结算成功'" style="margin-top: 10px"><el-button size="small" @click="handleCopy2('.copy-',scope.$index)">导购反应漏报</el-button></div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="ruleForm.problem === 2"
        :data="results"
        max-height="600"
        :span-method="objectSpanMethod"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="供应商"
          prop="supplierName"
          align="center"
          width="200">
        </el-table-column>
        <el-table-column
          label="业务员"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.managerId">{{scope.row.managerName}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="签约状态"
          prop="signStatusDesc"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{scope.row.message}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy-',0)">复制</el-button></div>
            <div style="margin-top: 10px"><el-button size="small" @click="openInvite(scope.row)">邀请</el-button></div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="ruleForm.problem === 3"
        :data="results"
        max-height="600"
        :span-method="objectSpanMethod"
        v-loading="ruleForm.loading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="导购员"
          prop="saleName"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="连锁"
          prop="storeBrand"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="门店"
          prop="storeName"
          align="center"
          width="200">
        </el-table-column>
        <el-table-column
          label="原因类型"
          prop="typeValue"
          align="center"
          width="120">
        </el-table-column>
        <el-table-column
          label="原因"
          prop="message"
          show-overflow-toolti
          align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top">
              <template slot="content">
                <div style="white-space: pre-line">{{scope.row.message}}</div>
              </template>
              <div class="multi-line-ellipsis" style="white-space: pre-line">{{scope.row.message}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <div><el-button size="small" @click="handleCopy2('.copy-',0)">复制</el-button></div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div :class="'copy-' + index" style="width: 100%;white-space: pre-line" v-if="results.length > 0" v-for="(item,index) in results">
      <div style="font-size: 1px;color: transparent;">{{item.copyMessage ? item.copyMessage : item.message}}</div>
      <div v-if="item.copyImgUrls">
        <img :src="url" v-for="url in item.copyImgUrls" style="width: 1px;height: 1px"/>
      </div>
    </div>

    <div :class="'copy2-' + index" style="width: 100%;white-space: pre-line" v-for="(item,index) in ruleForm.problemList">
      <div v-if="item.value || item.copyMessage || item.copyImgUrls">
        <div style="font-size: 1px;color: transparent;" v-if="item.copyMessage">
          {{item.copyMessage}}
        </div>
        <div style="font-size: 1px;color: transparent;" v-else-if="item.value">
          {{item.value}}
        </div>
        <div v-if="item.copyImgUrls">
          <img :src="url" v-for="url in item.copyImgUrls" style="width: 1px;height: 1px"/>
        </div>
      </div>
    </div>

    <el-dialog title="填写正确时间" :visible.sync="ticket.show" width="300px" v-loading="loading">
      <el-date-picker popper-class="datePicker" style="width: 100%" v-model="ticket.newTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :editable="false" type="datetime"></el-date-picker>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ticket.show = false" size="small">取 消</el-button>
        <el-button @click="ticket.previewList = [ticket.img]" size="small">查看小票</el-button>
        <el-button type="primary" @click="setTicketTime" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="获取邀请签约链接" :visible.sync="invite.show" width="400px" v-loading="loading" center>
      <div>
        <span>品牌：</span><el-input style="width: 300px" placeholder="请输入内容" v-model="invite.data.parentBrand" clearable></el-input>
      </div>
      <div style="margin-top: 10px" v-if="invite.data.msg">{{invite.data.link ? invite.data.info : invite.data.msg}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invite.show = false" size="small">取 消</el-button>
        <el-button v-if="!invite.data.msg" type="primary" @click="handleInvite" size="small">确 定</el-button>
        <el-button v-if="invite.data.link" type="primary" @click="handleCopy(invite.data.msg)" size="small">复制链接</el-button>
        <el-button v-else-if="invite.data.msg" type="primary" @click="handleCopy(invite.data.msg)" size="small">复制</el-button>
      </div>
    </el-dialog>

    <el-dialog title="滞留单挂起" :visible.sync="suspend.show" width="400px" v-loading="loading" center>
      <div>
        <span>挂起原因：</span><el-input style="width: 300px" placeholder="请输入内容" v-model="suspend.remark" clearable></el-input>
      </div>
      <div>
        <span>挂起天数：</span>
        <el-select style="width: 300px" v-model="suspend.day" placeholder="请选择挂起天数">
          <el-option label="1天" :value="1"></el-option>
          <el-option label="3天" :value="3"></el-option>
          <el-option label="7天" :value="7"></el-option>
          <el-option label="30天" :value="30"></el-option>
          <el-option label="永久" :value="1000"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="suspend.show = false">取 消</el-button>
        <el-button type="primary" @click="processSuspend">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增问答" :visible.sync="addProblem.show" width="400px" v-loading="loading" center>
      <div>
        <span>问题：</span><el-input style="width: 300px" placeholder="请输入问题" v-model="addProblem.data.question" clearable></el-input>
      </div>
      <div style="margin-top: 10px">
        <span>描述：</span><el-input style="width: 300px" placeholder="请输入描述" v-model="addProblem.data.description" clearable></el-input>
      </div>
      <div style="margin-top: 10px">
        <span>回答：</span><el-input style="width: 300px" placeholder="请输入回答" v-model="addProblem.data.answer" clearable></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProblem.show = false">取 消</el-button>
        <el-button type="primary" @click="addProblemConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <image-viewer v-if="ticket.show && ticket.previewList.length > 0" :z-index="9999" :initial-index="0" :on-close="() => ticket.previewList = []" :url-list="ticket.previewList"/>
  </div>
</template>

<script>
import {
  addProblemConfirm,
  invitationLink,
  problemSearch,
  processSuspend, retrial,
  setNewTicketTime
} from "@/api/ProblemAnalysis";
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue"
import {init} from "@/api/ProblemAnalysis";

export default {
  name: 'ProblemAnalysis',
  components:{ImageViewer},
  data() {
    return {
      ruleForm: {
        ticketTime: '',
        search: '',
        problemList:[{text:'为什么没发钱',description: '小票过期/“小票已过期”/“小票申报期限为”为什么小票会被退回？漏报产品/少发钱/结算产品数量不对？',value:1},
          {text:'如何销量申报/为什么不能报小票',value:2},{text:'不能提现/不愿意验证',
          description: '不能提现/不愿意验证/怎么提现/“请谨慎选择您的纳税人类型”/“需人脸验证签约”/“您领取的资金将作为劳务报酬收入进行税务申报”/“请确认以下为您身份证上的真实姓名”？',value:3},
          {text:'查看滞留单',value:4}],
        problem: 1,
        loading: false,
        timeRange: '0',
        abnormal: true
      },
      token: '',
      resultIndex: 0,
      rules: {
        problem: [
          {required: true, message: '请选择问题。', trigger: 'change'}
        ]
      },
      loading: false,
      results:[],
      ticket: {pid: '',show: false,newTime: '',img:'',previewList:[]},
      loading2: false,
      invite: {show: false,data:{}},
      suspend: {show: false, day: 1, remark : '', pids: [], batch: false},
      addProblem: {show: false, data: {}},
      answer: {value: '',index: 0}
    }
  },
  mounted() {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId === '15900973961' || supplierId === '17898848378') {
      this.token = localStorage.getItem('token')
      init(this.token).then(({data}) => {
        this.ruleForm.problemList = this.ruleForm.problemList.concat(data.data)
      })
      if (this.ruleForm.problemList.length === 1) {
        this.ruleForm.problem = this.ruleForm.problemList[0].value
      }
      let params = {
        problem: 4,
        timeRange: '2'
      }
      this.loading2 = true
      problemSearch(this.token,params).then(res => {
        if (res.data && res.data.length > 0) {
          let message = `存在${res.data.length}单滞留单（已进入平台审核两天，或未进入AA表），请留意处理`
          this.$alert(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                this.ruleForm.problem = 4;
                this.resultIndex = 0
                res.data.forEach(it => it.suspend = [])
                const withRule =res.data.filter(it => it.statusName !== '无提成规则')
                const withoutRule = res.data.filter(it => it.statusName === '无提成规则')
                this.results = [withRule, withoutRule]
              }
            }
          });
        } else {
          this.results = []
        }
      }).finally(() => this.loading2 = false)
    } else {
      this.$router.replace({ path: '/Console' })
    }
  },
  methods: {
    searchProblem() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.search && !this.ruleForm.ticketTime && this.ruleForm.problem !== 4) {
            let message = this.ruleForm.problem === 1 ? '请输入关键词或者小票交易时间' : '请输入关键词'
            this.$notify.error({
              title: '失败',
              message: message,
              position: 'bottom-right'
            })
            return false
          }
          this.ruleForm.loading = true
          const search = this.ruleForm.search ? this.ruleForm.search.trim() : ''
          let params = {
            pid: search.length > 11 ? search : '',
            phoneNumber: /^\d+$/.test(search) && search.length === 11 ? search : '',
            saleId: /^\d+$/.test(search) && search.length === 6 ? search : '',
            saleName: (!/^\d+$/.test(search) && search.length < 11) ? search : '',
            ticketTime: this.ruleForm.ticketTime,
            problem: this.ruleForm.problem,
            timeRange: this.ruleForm.problem === 4 ? '2' : this.ruleForm.timeRange,
            abnormal: this.ruleForm.abnormal
          }
          problemSearch(this.token,params).then(res => {
            if (res.data && res.data.length > 0) {
              if (this.ruleForm.problem === 4) {
                this.resultIndex = 0
                res.data.forEach(it => it.suspend = [])
                const withRule =res.data.filter(it => it.statusName !== '无提成规则')
                const withoutRule = res.data.filter(it => it.statusName === '无提成规则')
                this.results = [withRule, withoutRule]
              } else {
                this.results = res.data
              }
            } else {
              this.results = []
              this.$notify.error({
                title: '无结果',
                message: '未查到数据'
              })
            }
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '查询失败请联系管理员！'
            })
          }).finally(() => {
            this.ruleForm.loading = false
          })
        }
      })
    },
    addProblemOpen() {
      this.addProblem = {show: true, data: {}}
    },
    addProblemConfirm() {
      if (!this.addProblem.data.question || !this.addProblem.data.answer) {
        this.$notify.warning({
          title: '提示',
          message: '问题或答案不能为空'
        })
        return
      }
      addProblemConfirm(this.token,this.addProblem.data).then(({data}) => {
        console.log(data)
        if (data.data) {
          this.$notify.error({
            title: '失败',
            message: data.data
          })
        } else {
          this.ruleForm.problemList.push({text: this.addProblem.data.question,description: this.addProblem.data.description, value: this.addProblem.data.answer})
          this.$notify.success({
            title: '成功',
            message: '添加成功'
          })
        }
      })
    },
    chooseSuspend (pid) {
      if (pid) {
        this.suspend.pids = [pid]
      }
      this.suspend.remark = ''
      this.suspend.show = true
      this.suspend.day = 1
    },
    checkedClick(val,pid,index) {
      if (val.length === 0) {
        this.results[this.resultIndex][index].suspend = []
        this.suspend.pids = this.suspend.pids.filter(it => it !== pid)
      } else {
        this.suspend.pids.push(pid)
      }
    },
    cancelSuspend() {
      this.suspend.batch = false;
      this.suspend.pids = []
      this.results[this.resultIndex].forEach(it => it.suspend = [])
    },
    processSuspend() {
      if (!this.suspend.pids || this.suspend.pids.length === 0) {
        this.$notify.warning({
          title: '提示',
          message: '请选择挂起流程',
          position: 'bottom-right'
        })
        return
      }
      if (!this.suspend.remark) {
        this.$notify.warning({
          title: '提示',
          message: '挂起原因不能为空',
          position: 'bottom-right'
        })
        return
      }
      this.loading = true
      processSuspend(this.token,this.suspend).then(() => {
        this.results[this.resultIndex] = this.results[this.resultIndex].filter(item => !this.suspend.pids.includes(item.pid))
        this.suspend.pids = []
        this.suspend.remark = ''
        this.suspend.show = false
        this.suspend.batch = false
        this.$notify.success({
          title: '成功',
          message: '挂起成功'
        })
      }).finally(() => this.loading = false)
    },
    openInvite(row) {
      this.invite = {
        show: true,
        data: {
          saleId: row.saleId,
          parentBrand: ''
        }
      }
    },
    handleInvite() {
      if (!this.invite.data || !this.invite.data.parentBrand) {
        this.$notify.warning({
          title: '提示',
          message: '请填写品牌',
          position: 'bottom-right'
        })
        return
      }
      this.loading = true
      invitationLink(this.token,this.invite.data).then(({data}) => {
        if (data && data.data) {
          this.invite.data.link = data.data.link
          this.invite.data.info = data.data.info
          this.invite.data.msg = data.data.msg
        } else {
          this.$notify.error({
            title: '失败',
            message: '无可推荐签约！'
          })
        }
      }).finally(() => this.loading = false)
    },
    handleCopy(text) {
      if (!text) return
      this.$copyText(text).then(
        (e) => {
          this.$message.success('复制成功!')
        },(e) =>{
          this.$message.error('复制失败!')
        }
      )
    },
    handleCopy2(className,index) {
      let selection = window.getSelection();
      let container = document.querySelector(className + index);
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      const range = document.createRange();
      range.selectNode(container);
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
      this.$message.success('复制成功!')
    },
    openNewTicket(row) {
      this.ticket = {
        pid: row.pid,
        show: true,
        newTime: null,
        img: row.img,
        previewList: []
      }
    },
    setTicketTime() {
      if (!this.ticket.newTime) {
        this.$message.error('请填写正确时间!')
        return
      }
      const params = {
        pid: this.ticket.pid,
        newTime: this.ticket.newTime
      }
      this.loading = true
      setNewTicketTime(this.token,params).then(({data}) => {
        if (data.code === 0) {
          this.$notify.error({
            title: '失败',
            message: data.msg
          })
        } else {
          this.$set(this.results.find(item => item.pid === this.ticket.pid), 'sub', 'sub2')
          this.$notify.success({
            title: '成功',
            message: '修改小票时间成功'
          })
        }
        this.ticket.show = false
      }).finally(() => this.loading = false)
    },
    problemChange() {
      this.results = []
      if (!this.ruleForm.search || !/^\d+$/.test(this.ruleForm.search) || this.ruleForm.search.length !== 11) {
        this.ruleForm.search = ''
      }
      if (this.ruleForm.problem && !Number.isFinite(this.ruleForm.problem)) {
        const index = this.ruleForm.problemList.findIndex(item => item.value === this.ruleForm.problem)
        this.answer = {value:this.ruleForm.problem,index: index}
      } else {
        this.answer = {value:'',index: 0}
      }
    },
    //取回重审
    retrial(row,index) {
      this.$confirm(row.autoBack ? '您确定要取回重审吗？这将恢复为业务员审核状态。' : '您确定要取回重审吗？这将恢复为审单员审核状态。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ruleForm.loading = true
        retrial(this.token,row.pid).then(({data}) => {
          if (data.data) {
            this.$notify({
              type: 'success',
              message: '取回重审成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.$set(this.results, index, data.data)
          } else {
            this.$notify({
              type: 'error',
              message: '取回失败，请刷新后重试',
              title: '失败',
              position: 'bottom-right'
            })
          }
        }).finally(() => this.ruleForm.loading = false)
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 5) {
        if (rowIndex % this.results.length === 0) {
          return {
            rowspan: this.results.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
}
</script>

<style>
.datePicker .el-button--text {
  display: none;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制显示行数 */
  overflow: hidden;
}

.problem .el-form-item__content {
  line-height: 30px !important;
}
</style>
